<template>
  <Head title="プライバシーポリシー">
    <meta name="description" content="プライバシーポリシー">
    <meta name="robots" content="noindex, nofollow">
  </Head>
  
  <BreezeGuestLayout>
    <section class="privacy">
      <h1>プライバシーポリシー</h1>

      <div class="block">
        <h2>お客様から取得する情報</h2>
        <p>当社は、お客様から以下の情報を取得します。</p>
        <ul>
          <li>氏名(ニックネームやペンネームも含む)</li>
          <li>年齢または生年月日</li>
          <li>性別</li>
          <li>職業、職歴、学歴</li>
          <li>メールアドレス</li>
          <li>住所</li>
          <li>写真や動画</li>
          <li>外部サービスでお客様が利用するID、その他外部サービスのプライバシー設定によりお客様が連携先に開示を認めた情報</li>
          <li>Cookie(クッキー)を用いて生成された識別情報</li>
          <li>OSが生成するID、端末の種類、端末識別子等のお客様が利用するOSや端末に関する情報</li>
          <li>当社ウェブサイトの滞在時間、入力履歴、購買履歴等の当社ウェブサイトにおけるお客様の行動履歴</li>
          <li>当社アプリの起動時間、入力履歴、購買履歴等の当社アプリの利用履歴</li>
          <li>お客様の位置情報</li>
        </ul>
      </div>
      <div class="block">
        <h2>お客様の情報を利用する目的</h2>
        <p>当社は、お客様から取得した情報を、以下の目的のために利用します。</p>
        <ul>
          <li>当社サービスに関する登録の受付、お客様の本人確認、認証のため</li>
          <li>お客様の当社サービスの利用履歴を管理するため</li>
          <li>利用料金の決済のため</li>
          <li>当社サービスにおけるお客様の行動履歴を分析し、当社サービスの維持改善に役立てるため</li>
          <li>広告の配信、表示及び効果測定のため</li>
          <li>お客様の趣味嗜好にあわせたターゲティング広告を表示するため</li>
          <li>当社のサービスに関するご案内をするため</li>
          <li>提携する事業者・サービスのご案内をお送りするため</li>
          <li>お客様からのお問い合わせに対応するため</li>
          <li>当社の規約や法令に違反する行為に対応するため</li>
          <li>当社サービスの変更、提供中止、終了、契約解除をご連絡するため</li>
          <li>当社規約の変更等を通知するため</li>
          <li>以上の他、当社サービスの提供、維持、保護及び改善のため</li>
        </ul>
      </div>
      <div class="block">
        <h2>安全管理のために講じた措置</h2>
        <p>当社が、お客様から取得した情報に関して安全管理のために講じた措置につきましては、末尾記載のお問い合わせ先にご連絡をいただきましたら、法令の定めに従い個別にご回答させていただきます。</p>
        <h2>第三者提供</h2>
        <p>当社は、お客様から取得する情報のうち、個人データ（個人情報保護法第２条第６項）に該当するものついては、あらかじめお客様の同意を得ずに、第三者（日本国外にある者を含みます。）に提供しません。<br>
        但し、次の場合は除きます。</p>
        <ul>
          <li>個人データの取扱いを外部に委託する場合</li>
          <li>当社や当社サービスが買収された場合</li>
          <li>事業パートナーと共同利用する場合（具体的な共同利用がある場合は、その内容を別途公表します。）</li>
          <li>その他、法律によって合法的に第三者提供が許されている場合</li>
        </ul>
      </div>
      <div class="block">
        <h2>アクセス解析ツール</h2>
        <p>当社は、お客様のアクセス解析のために、「Googleアナリティクス」を利用しています。Googleアナリティクスは、トラフィックデータの収集のためにCookieを使用しています。トラフィックデータは匿名で収集されており、個人を特定するものではありません。Cookieを無効にすれば、これらの情報の収集を拒否することができます。詳しくはお使いのブラウザの設定をご確認ください。Googleアナリティクスについて、詳しくは以下からご確認ください。<br>
        <a href="https://marketingplatform.google.com/about/analytics/terms/jp/" target="_blank">https://marketingplatform.google.com/about/analytics/terms/jp/</a>
        </p>
      </div>
      <div class="block">
        <h2>広告の配信</h2>
        <p>当社は、Google及びそのパートナー（第三者配信事業者）の提供する広告を設置しています。広告配信にはCookieを使用し、お客様が過去に当社ウェブサイトやその他のサイトにアクセスした情報に基づいて広告を配信します。Google やそのパートナーは、Cookieを使用することにより適切な広告を表示しています。</p>
        <p>お客様は、以下のGoogleアカウントの広告設定ページから、パーソナライズ広告を無効にできます。<br>
        <a href="https://adssettings.google.com/u/0/authenticated" target="_blank">https://adssettings.google.com/u/0/authenticated</a>
        </p>
        <p>また aboutads.info のページにアクセスし、パーソナライズ広告掲載に使用される第三者配信事業者のCookieを無効にすることもできます。<br>
        その他、GoogleによるCookieの取り扱い詳細については、以下のGoogleのポリシーと規約のページをご覧ください。<br>
        <a href="https://policies.google.com/technologies/ads" target="_blank">https://policies.google.com/technologies/ads</a>
        </p>
        <p>当社は、以下のアフィリエイトプログラムに参加しています。そのため、第三者がコンテンツおよび宣伝を提供したり、訪問者から直接情報を収集し、訪問者のブラウザにCookieを設定したり、Cookieを認識したりする場合があります。<br>
        Cookieを無効にすれば、これらの情報の収集を拒否することができます。詳しくはお使いのブラウザの設定をご確認ください。</p>
        <ul>
          <li>Amazonアソシエイト・プログラム</li>
          <li>A8.net</li>
        </ul>
      </div>
      <div class="block">
        <h2>プライバシーポリシーの変更</h2>
        <p>当社は、必要に応じて、このプライバシーポリシーの内容を変更します。この場合、変更後のプライバシーポリシーの施行時期と内容を適切な方法により周知または通知します。</p>
      </div>
      <div class="block">
      <h2>お問い合わせ</h2>
        <p>お客様の情報の開示、情報の訂正、利用停止、削除をご希望の場合は、<a href="https://docs.google.com/forms/d/e/1FAIpQLSfUW4p1DcGSk-HYBS5uA6WZvjk5L5U7KUw0dxSjUlsJn3UDuw/viewform?fbzx=-1185234441729679604" target="_blank">こちらのお問い合わせフォーム</a>からご連絡ください。<br>
        この場合、必ず、運転免許証のご提示等当社が指定する方法により、ご本人からのご請求であることの確認をさせていただきます。<br>
        なお、情報の開示請求については、開示の有無に関わらず、ご申請時に一件あたり1,000円の事務手数料を申し受けます。</p>
      </div>
      <div class="block">
        <h2>事業者の名称</h2>
        <p>キャラカル合同会社</p>
      </div>
      <div class="block">
        <h2>代表者氏名</h2>
        <p>吉田 智章</p>
      </div>
      <div class="block">
        <h2>事業者の住所</h2>
        <p>東京都中央区銀座8-10-5 DENSANビル G-20149</p>
      </div>
      <div class="block">
        2022年10月22日 制定<br>
        2023年01月07日 改定
      </div>

    </section>
  </BreezeGuestLayout>
</template>

<script>
  import BreezeGuestLayout from '@/Layouts/Guest.vue'
  import { Head, Link, onMounted } from '@inertiajs/inertia-vue3';
  import Logo from '@/Shared/Logo'
  
  export default {
    components: {
    BreezeGuestLayout,
    Head,
    Link,
    Logo,
    },
  }
  </script>